import React from "react";

function Container(props){
    return <div className="uk-container uk-container-xlarge uk-padding-small">{props.children}</div>
}

export default Container;